var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "500" },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "modal-edit-category", attrs: { flat: "" } },
        [
          _c(
            "v-toolbar",
            { attrs: { color: "primary", dark: "", flat: "" } },
            [
              _c("v-toolbar-title", [
                _vm._v("Detalhes do rateio - Rateio atual"),
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            {
              staticClass: "pt-4 pb-4 pr-4 pl-4",
              attrs: { wrap: "", row: "" },
            },
            [
              _vm.loading
                ? _c("AppLoadingIcon", {
                    staticClass: "my-4",
                    attrs: { color: "#CCCCCC" },
                  })
                : _c(
                    "div",
                    [
                      _c(
                        "v-flex",
                        {
                          staticClass: "pt-3 pb-3 gray--text",
                          attrs: { lg12: "" },
                        },
                        [
                          _c("strong", [_vm._v("Realizado por:")]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.apportionmentDetails.doneBy) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        {
                          staticClass: "pt-3 pb-3 gray--text",
                          attrs: { lg12: "" },
                        },
                        [
                          _c("strong", [_vm._v("Vendedor:")]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.apportionmentDetails.seller) +
                              "%\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        {
                          staticClass: "pt-3 pb-3 gray--text",
                          attrs: { lg12: "" },
                        },
                        [
                          _c("strong", [_vm._v("Equipe:")]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.apportionmentDetails.team) +
                              "%\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }